module.exports = __webpack_public_path__ + "static/media/buy_miles_teal.ae59fa6c.svg";